import React, { useEffect, useState } from "react";
import { Badge, Dropdown, Spinner } from "react-bootstrap";

const ClientSelector = ({ currentClient, onClientChange }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
      if (userData.client_id !== undefined && userData.client_id !== null) {
        setClients([
          {
            id: userData.client_id,
            company_name:
              userData.company_name || `Client ${userData.client_id}`,
            status: "active",
          },
        ]);
      }
    } catch {
      setError("Failed to load client data");
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSelect = (clientId) => {
    const selected = clients.find(
      (client) => String(client.id) === String(clientId),
    );

    if (selected) {
      onClientChange(selected);
    }
  };

  if (loading) return <Spinner animation="border" size="sm" />;
  if (error) return <span className="text-danger small">{error}</span>;
  if (clients.length === 0) return null;

  return (
    <Dropdown>
      <Dropdown.Toggle variant="outline-dark" size="sm" id="client-selector">
        {currentClient?.company_name || "Select Client"}
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        {clients.map((client) => (
          <Dropdown.Item
            key={client.id}
            active={String(currentClient?.id) === String(client.id)}
            onClick={() => handleSelect(client.id)}
          >
            {client.company_name}
            {client.status === "inactive" && (
              <Badge bg="danger" className="ms-2">
                Inactive
              </Badge>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ClientSelector;
